import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import Permission from '../utils/permission';
import Action from '../utils/operationsActions';
import {
    CommonDrawer, MainLayoutGroups, ModalComponent, OutPutResult as Result, CancelRequest, ViewFeesModels, UploadUserDocs,
    ViewCompanyDetails, SendUserOtp, CreateDepartments, DeployCompany, CreateUser, CreateCompanyGroup, CreateRequest,
    CreateFeesModel, ViewFeesGroups, CreateFeesGroup, ViewFeesCompanies, CreateUserComment, EditCompaniesFees, AssignUserRoles,
    RevokeRequest, ViewUserSalary, ResolveIssues, ResolveIssuesByDate, BulkUpdateUserStatus, ApproveUserDocs, UnAssignUserRoles,
    ViewUserSuspending, UserUnSuspending, CompaniesGroup, ViewUserStatus, UpdateUserCompany, ViewAssignUser, GetBlockingIssues,
    BulkRecalculateRequest, BulkCreateComments, BulkUpdateRequestsStatus, BulkCreateUserInfo, UpdateRequest, ViewUpdateCompanyCaps,
    ViewResetPassword, ViewRequestInfo, EditUserInfo, BulkUpdateUserInfo, UpdateGlobalCaps, ViewRequestFees,
    ViewEditApprovedUserSInfo, ViewUpdateBankInfo, UpdateUserCaps, ViewUserInfo, BulkUpdateApprovedUsersInfo, SuspendGlobalServices, 
    SuspendCompanyServices, isActionDisabledForSA, ViewRequestsList, EditCompany, CreateCompany, StartingCall,
    TransactingUsers, UpdateDepartment,
} from '@operations/shared';
import SmsNotification from '../actionsGroups/smsNotification';
import OfflineShoppingTransactions from '../actionsGroups/offlineShoppingTransactions';
import { connect } from 'react-redux';
import { stepperMoving, emptyDrawer, move, hrStepper } from '../stores/actions';
import { updateBulkApprovedUsersAdvanced, addRequestsCommentsApi, addUsersCommentsApi, uploadUserDocsApi, uploadApprovedUserDocsApi } from '../utils/apisConsts';
import helper from '../utils/helper';
import { ConfigProvider } from 'antd';
import EarlyPayment from '../actionsGroups/createEarlyPayment/earlyPayment';
import { bulkUpdateApprovedUserAllInfoTemplate, createRequestsCommentsTemplate, createUsersCommentsTemplate } from '../utils/bulkSheetsTemplates';
import { CreateOffer as CreateFreePeriodOffer } from '../actionsGroups/freePeriodOffer/createOffer';
import ApproveNewInvoice from '../actionsGroups/approveInvoiceV2/approve';
import ViewAccountsEntries from '../actionsGroups/accountsEntries/viewAccountsEntries';
import { ViewSubmitNewDiscount } from '../actionsGroups/requests/submitDiscount/ViewSubmitNewDiscount';
import { ViewRequestEarlySettlement } from '../actionsGroups/earlySettlements/ViewRequestEarlySettlement';
import { ViewSubmitEarlySettlement } from '../actionsGroups/earlySettlements/ViewSubmitEarlySettlement';
import { ViewRefundExcess } from "../actionsGroups/refundExcess/viewRefundExcess";
import ViewUserCollection from '../actionsGroups/userCollections/ViewUserCollections';
import { ViewCollection } from '../actionsGroups/addIdentifiedOrUnIdentifiedCollection/viewCollection';
import { ViewUnidentifiedCollection } from '../actionsGroups/unidentifiedCollection/viewUnidentifiedCollection';
import { SuspendFreePeriodOffers } from '../actionsGroups/freePeriodOffer/viewOffers/Index';
import { InvoicesTable } from '../actionsGroups/invoicesTax/InvoicesTable';
import { CollectAndCancel } from '../actionsGroups/collectAndcancel/collectAndCancle';
import { CommodityPrice } from '../actionsGroups/CommodityPrice';
import { AddRewardsAction } from '../actionsGroups/addRewards/Index';
import { IDatCategoryProps, ICategoriesState } from '@operations/shared/src/utils/commonInterfaces';
import BulkCreateHousingIqamaRequests from '../actionsGroups/bulkCreateHousingIqama/bulkCreateHousingIqamaRequests';

const intFrameWidth: number = window.innerWidth;
const FULL_WIDTH = intFrameWidth <= 500 ? 370 : intFrameWidth - 160;
const FULL_WIDTH_HR = intFrameWidth <= 500 ? 370 : intFrameWidth - 200;

const ACTION_CONFIG: Record<string, { width?: number; component: () => JSX.Element }> = {
    updateBulkUsers: { width: 1282, component: () => <BulkUpdateUserInfo /> },
    createBulkUsers: { width: 1282, component: () => <BulkCreateUserInfo /> },
    createRequest: { width: 1100, component: () => <CreateRequest noLimits={false} /> },
    createExceptionRequest: { width: 1100, component: () => <CreateRequest noLimits={true} /> },
    cancelRequest: { width: 1000, component: () => <CancelRequest /> },
    smsNotification: { component: () => <SmsNotification /> },
    createCompany: { width: 1000, component: () => <CreateCompany /> },
    cancelMerchantRequest: { width: FULL_WIDTH, component: () => <OfflineShoppingTransactions /> },
    createServicesGroup: { width: 820, component: () => <CreateFeesGroup /> },
    createFeesModel: { width: 820, component: () => <CreateFeesModel /> },
    getServiceGroup: { width: 820, component: () => <ViewFeesGroups /> },
    getModelsFeesDetails: { width: 1200, component: () => <ViewFeesModels /> },
    getCompaniesFees: { width: 820, component: () => <ViewFeesCompanies /> },
    addCallInfo: { width: 1000, component: () => <StartingCall /> },
    getUserInfo: { width: 1000, component: () => <ViewUserInfo /> },
    getAllRequests: { width: FULL_WIDTH, component: () => <ViewRequestsList /> },
    updateUserInfo: { width: 1000, component: () => <EditUserInfo /> },
    changeDeploymentStatus: { width: 1000, component: () => <DeployCompany /> },
    getOneCompany: { width: 1000, component: () => <ViewCompanyDetails /> },
    approveHighAmount: { width: 1000, component: () => <ViewRequestInfo /> },
    BulkCreateHousingIqama: { width: 1000, component: () => <BulkCreateHousingIqamaRequests /> },
    assignUserToFeesModel: { width: 1000, component: () => <ViewAssignUser /> },
    approveUserDocs: { width: 1000, component: () => <ApproveUserDocs /> },
    createCompanyGroup: { component: () => <CreateCompanyGroup /> },
    getCompaniesGroups: { width: 1000, component: () => <CompaniesGroup /> },
    getUserLastOtp: { component: () => <SendUserOtp /> },
    sendOtpViaTwilio: { component: () => <SendUserOtp /> },
    updateStatus: { width: 1000, component: () => <ViewUserStatus /> },
    updateUserSalary: { width: 1100, component: () => <ViewUserSalary /> },
    updateBankInfo: { width: 1100, component: () => <ViewUpdateBankInfo /> },
    updateApprovedUserInfo: { width: 1000, component: () => <ViewEditApprovedUserSInfo /> },
    updateBulkStatus: { width: 1282, component: () => <BulkUpdateUserStatus /> },
    suspendUser: { width: 1100, component: () => <ViewUserSuspending /> },
    unSuspendUser: { width: 1100, component: () => <UserUnSuspending /> },
    updateForceResetPassword: { width: 1100, component: () => <ViewResetPassword /> },
    uploadUserDocs: { width: 1000, component: () => <UploadUserDocs apiLink={uploadUserDocsApi} /> },
    uploadApprovedUserDocs: { width: 1000, component: () => <UploadUserDocs apiLink={uploadApprovedUserDocsApi} /> },
    updateUserCap: { width: 1000, component: () => <UpdateUserCaps /> },
    updateGlobalServicesCaps: { width: 1000, component: () => <UpdateGlobalCaps /> },
    updateCompanyCap: { width: 1000, component: () => <ViewUpdateCompanyCaps /> },
    updateCompanySuspension: { width: 1000, component: () => <SuspendCompanyServices /> },
    updateGlobalServiceSuspension: { width: 1000, component: () => <SuspendGlobalServices /> },
    hrGetTransactingUsers: { width: FULL_WIDTH_HR, component: () => <TransactingUsers /> },
    assignUserToRole: { width: 1000, component: () => <AssignUserRoles /> },
    unAssignUserFromRole: { width: 1000, component: () => <UnAssignUserRoles /> },
    updateUserCompany: { width: 1200, component: () => <UpdateUserCompany /> },
    updateBulkApprovedUsers: { width: 1282, component: () => <BulkUpdateApprovedUsersInfo /> },
    externalPayment: { width: 1282, component: () => <EarlyPayment /> },
    revokeRequest: { width: 1282, component: () => <RevokeRequest /> },
    updateCompanyInfo: { width: 1000, component: () => <EditCompany editAllInfo={false} /> },
    updateCompanyInfoAdvance: { width: 1000, component: () => <EditCompany editAllInfo={true} /> },
    updateBulkApprovedUsersAdvanced: { width: 1282, component: () => <BulkUpdateApprovedUsersInfo template={bulkUpdateApprovedUserAllInfoTemplate} api={updateBulkApprovedUsersAdvanced} /> },
    resolveAdvanceIssuesManually: { width: 1200, component: () => <ResolveIssues /> },
    resolveAdvancesIssuesAutomatically: { component: () => <ResolveIssuesByDate /> },
    newDeductions: { width: 1200, component: () => <ApproveNewInvoice lock /> },
    bulkChangeRequestsStatus: { width: 1100, component: () => <BulkUpdateRequestsStatus /> },
    updateRequest: { width: 1100, component: () => <UpdateRequest noLimits={false} /> },
    addRequestsComments: { width: 1100, component: () => <BulkCreateComments template={createRequestsCommentsTemplate} title="Request" api={addRequestsCommentsApi} /> },
    addUsersComments: { width: 1100, component: () => <BulkCreateComments template={createUsersCommentsTemplate} title="User" api={addUsersCommentsApi} /> },
    recalculateRequests: { width: 1100, component: () => <BulkRecalculateRequest /> },
    createDepartments: { width: 1100, component: () => <CreateDepartments /> },
    userCreateSingleComment: { width: 1100, component: () => <CreateUserComment /> },
    getBlockingIssues: { width: 1200, component: () => <GetBlockingIssues /> },
    createUser: { component: () => <CreateUser /> },
    viewRequestFees: { width: 900, component: () => <ViewRequestFees /> },
    assignCompanyToFeesModel: { width: 900, component: () => <EditCompaniesFees isDeployedCompany /> },
    assignNonDeployedCompanyToFeesModel: { width: 900, component: () => <EditCompaniesFees isDeployedCompany={false} /> },
    generateAccountingEntries: { width: 900, component: () => <ViewAccountsEntries /> },
    addInvoiceCollection: { width: 900, component: () => <ViewUserCollection /> },
    submitDiscount: { width: 1200, component: () => <ViewSubmitNewDiscount /> },
    requestEarlySettlement: { width: 900, component: () => <ViewRequestEarlySettlement /> },
    submitEarlySettlement: { width: 900, component: () => <ViewSubmitEarlySettlement /> },
    AdvancePaymentRefund: { width: 900, component: () => <ViewRefundExcess /> },
    updateDepartmentBalancePercent: { width: 900, component: () => <UpdateDepartment /> },
    addUnassignedCollection: { width: 900, component: () => <ViewCollection /> },
    getAndAssignUnidentifiedDeposits: { width: 1200, component: () => <ViewUnidentifiedCollection /> },
    createFreePeriodOffer: { width: 900, component: () => <CreateFreePeriodOffer /> },
    viewAndSuspendFreePeriodOffer: { width: 1200, component: () => <SuspendFreePeriodOffers /> },
    getTaxableInvoice: { width: 1200, component: () => <InvoicesTable key={Date.now()} /> },
    collectAndCancel: { width: 900, component: () => <CollectAndCancel /> },
    setCommodityPrice: { width: 1200, component: () => <CommodityPrice /> },
    addUserReward: { width: 900, component: () => <AddRewardsAction /> },
};

const PERMISSION_DENIED_VIEW = (actionName: string) => ({
    layout: <Result status="403" title="Permission Issue" subTitle={`${helper.unCamelCase(actionName)} action is out of your permissions`} />,
    title: 'Out Of Permissions',
});
class Categories extends Component<IDatCategoryProps, ICategoriesState> {
    state: ICategoriesState = {
        loading: false,
        drawerLayout: null,
        drawerTitle: '',
        visibleDrawer: false,
        drawerWidths: null,
        hiddenScroll: false,
        dataForm: {},
        visibleChildDrawer: false,
        visibleModal: false,
        inputChange: false,
    };

    componentDidMount() {
        this.openDrawerByDynamicId();
    }

    componentDidUpdate(prevProps: any, prevState: ICategoriesState) {
        if (!this.state.inputChange && prevState.inputChange === this.state.inputChange && this.getInputs(true).length > 2) {
            this.setState({ inputChange: true });
        }
        const prevAction = prevProps.match?.params?.actionName;
        const nextAction = this.props.match?.params?.actionName;
        const prevTarget = `${(prevProps.location?.pathname || '').split('/').filter(Boolean)[0] || ''}/${prevAction || ''}`;
        const nextTarget = `${(this.props.location?.pathname || '').split('/').filter(Boolean)[0] || ''}/${nextAction || ''}`;
        if (nextAction && prevTarget !== nextTarget) {
            this.openDrawerByDynamicId();
        }
    }

    activeAction = (actionName: string) => {
        const config = ACTION_CONFIG[actionName];
        if (!config) return undefined;
        this.setState({ drawerWidths: config.width ?? 820, hiddenScroll: false });
        return config.component();
    };

    openDrawerByDynamicId = () => {
        const { actionName } = this.props.match.params;
        if (!actionName) return;

        this.props.emptyDrawer(true);
        if (isActionDisabledForSA(actionName)) {
            const { layout, title } = PERMISSION_DENIED_VIEW(actionName);
            this.setState({ visibleDrawer: true, drawerLayout: layout, drawerTitle: title });
            return;
        }

        const availableActions: string[] = Permission.handleGettingPermission('permission');
        const actions = Action.actionsCreated();
        const matched = actions.find((a: { actionName: string }) => a.actionName === actionName);

        if (!matched) {
            const layout = this.activeAction(actionName);
            if (!layout) return;
            this.setState({ visibleDrawer: true, drawerLayout: layout, drawerTitle: helper.unCamelCase(actionName) });
            return;
        }

        const { layout, title } = availableActions.includes(actionName)
            ? { layout: this.activeAction(actionName), title: matched.name }
            : PERMISSION_DENIED_VIEW(actionName);

        this.setState({ visibleDrawer: true, drawerLayout: layout ?? null, drawerTitle: title });
    };

    selectedAction = (actionData: any) => {
        this.props.emptyDrawer(true);
        this.props.history.push(`${this.props.location.pathname}/${actionData.actionName}`);
        this.setState({
            visibleDrawer: true,
            drawerLayout: this.activeAction(actionData.actionName) ?? null,
            drawerTitle: actionData.name,
        });
    };

    getInputs = (onlyInputs?: boolean) => {
        const inputs = Array.from(document.getElementsByTagName("input"));
        const textareas = Array.from(document.getElementsByTagName("textarea"));
        if (onlyInputs) return [...inputs, ...textareas];
        return [...inputs, ...textareas, ...Array.from(document.getElementsByTagName("button"))];
    };

    openModal = () => this.setState({ visibleModal: true });

    cancelDrawer = (directClose?: string) => {
        if (directClose === 'direct') { this.confirmationModal(); return; }
        const hasValues = this.getInputs().some(el => (el as HTMLInputElement).value);
        if (hasValues || (this.state.inputChange && this.props.stepNumber > 0)) {
            this.openModal();
            return;
        }
        this.confirmationModal();
    };

    confirmationModal = () => {
        Array.from(document.getElementsByTagName("form")).forEach(f => f.reset());
        this.setState({ visibleDrawer: false, visibleModal: false, drawerWidths: null });
        this.props.history.push(`/${Permission.handleGettingPath()}`);
        this.props.stepperMoving(0);
        this.props.move(0);
        this.props.hrStepper(0);
        this.props.emptyDrawer(false);
        helper.resetAccountTableInStepper();
    };
    handleCloseModal = () => this.setState({ visibleModal: false });
    render() {
        const { visibleModal, drawerLayout, drawerTitle, visibleDrawer, drawerWidths, hiddenScroll } = this.state;
        const isArabic = helper.isArabic(drawerTitle);
        return (
            <>
                <MainLayoutGroups
                    groupActions={Action.actionsCreated()}
                    selectedAction={this.selectedAction}
                    permission={Permission.handleGettingPermission('permission')}
                />
                <CommonDrawer
                    drawerLayout={drawerLayout}
                    drawerWidth={drawerWidths ?? 820}
                    drawerTitle={drawerTitle}
                    visible={visibleDrawer}
                    showDrawer={this.selectedAction}
                    cancelDrawer={this.cancelDrawer}
                    hiddenScroll={hiddenScroll}
                />
                {isArabic ? (
                    <ConfigProvider direction='rtl'>
                        <ModalComponent
                            okText='نعم' cancelText='لا'
                            visibleModal={visibleModal}
                            handleAcceptModal={this.confirmationModal}
                            content={<p style={{ fontSize: '17px', fontWeight: 'lighter' }}>انت ستغادر هذه الصفحه. هل أنت متأكد؟</p>}
                            title='تحذير'
                            handleCloseModal={this.handleCloseModal}
                        />
                    </ConfigProvider>
                ) : (
                    <ModalComponent
                        okText='Yes' cancelText='No'
                        visibleModal={visibleModal}
                        handleAcceptModal={this.confirmationModal}
                        content={<p style={{ fontSize: '17px', fontWeight: 'lighter' }}>You have attempted to leave this page. Are you sure?</p>}
                        title='Warning Message'
                        handleCloseModal={this.handleCloseModal}
                    />
                )}
            </>
        );
    }
}
const mapStateToProps = (state: any) => ({ stepNumber: state.actionsReducer.stepNumber });
export default withRouter(connect(mapStateToProps, { stepperMoving, move, hrStepper, emptyDrawer })(Categories));
